// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './components/App'
import store from './data/store'
import Intro from './components/Intro'
import Bio from './components/Bio'
Vue.config.productionTip = false
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: Intro
  },
  {
    path: '/bio/:id',
    component: Bio
  }
]

const router = new VueRouter({
  routes
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js